const HEAT_SUPPLY_KEY = 1;
const COLD_WATER_SUPPLY_KEY = 2;
const GAS_COMMUNICATION_KEY = 5;
const POWER_SUPPLY_KEY = 4;
const DRAINAGE_KEY = 3;
const LIGHING_KEY = 6;

const EVENT_TYPE_ALARM_ID = 1;
const EVENT_TYPE_INCIDENT_ID = 2;
const EVENT_TYPE_PLANNING_ID = 3;

const DEFAULT_GRID_TYPE = [
  {
    id: HEAT_SUPPLY_KEY,
    gridTypeId: 1,
    gridTitle: "Теплоснабжение",
  },
  {
    id: COLD_WATER_SUPPLY_KEY,
    gridTypeId: 2,
    gridTitle: "Водоснабжение",
  },
  {
    id: GAS_COMMUNICATION_KEY,
    gridTypeId: 3,
    gridTitle: "Газоснабжение",
  },
  {
    id: LIGHING_KEY,
    gridTypeId: 6,
    gridTitle: "Освещение",
  },
  {
    id: DRAINAGE_KEY,
    gridTypeId: 5,
    gridTitle: "Водоотведение",
  },
  {
    id: POWER_SUPPLY_KEY,
    gridTypeId: 4,
    gridTitle: "Электроснабжение",
  },
];

export {
  HEAT_SUPPLY_KEY,
  COLD_WATER_SUPPLY_KEY,
  GAS_COMMUNICATION_KEY,
  LIGHING_KEY,
  DRAINAGE_KEY,
  POWER_SUPPLY_KEY,
  EVENT_TYPE_ALARM_ID,
  EVENT_TYPE_INCIDENT_ID,
  EVENT_TYPE_PLANNING_ID,
  DEFAULT_GRID_TYPE,
};
